import { render, staticRenderFns } from "./dashboardLeft.vue?vue&type=template&id=202b6be6&"
import script from "./dashboardLeft.vue?vue&type=script&lang=js&"
export * from "./dashboardLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports